import { Controller } from '@hotwired/stimulus';

// Liste : son adresse courante (filtres, tri, page,
// recherche) gardée pour la session, sous le chemin de la liste, au
// chargement et après chaque recherche (le retour d'une fiche y ramène).
export default class extends Controller {
    connect() {
        this.save();
    }

    save() {
        try {
            sessionStorage.setItem(`list:${window.location.pathname}`, window.location.href);
        } catch {
            // Stockage indisponible (navigation privée) : retour vers la liste nue.
        }
    }
}
